import { Form } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import { useCallback } from 'react';

export function useToggleableRadio(fieldName: NamePath) {
	const form = Form.useFormInstance();

	const handleRadioClick = useCallback(
		(selectedValue: string) => {
			const currentValue = form.getFieldValue(fieldName);
			const newValue = currentValue === selectedValue ? undefined : selectedValue;
			form.setFieldValue(fieldName, newValue);
		},
		[form, fieldName]
	);

	return handleRadioClick;
}
